import { Home } from "./View/Home";
const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default App;
